import { Navigate, Outlet, useLocation } from 'react-router-dom';

import useFixPage from '../../hooks/useFixPage';

import PageContainer from '../../components/Containers/PageContainer';
import Tabs from '../../components/Tabs';
import PageTitle from '../../components/PageTitle';
import { useAuth } from '../../../contexts/AuthContext';
import { isProviderUserOwnerOrAdminAuthorized } from '../../../lib/auth';
import { useFeatureFlags } from '../../../contexts/FeatureFlagContext';
import { Feature } from '../../../generated/graphql';
import classNames from 'classnames';

const Settings = () => {
  useFixPage();

  const { authedProviderUser, showUpgradeBanner } = useAuth();
  const { isFeatureEnabled } = useFeatureFlags();
  const location = useLocation();

  const isPublicApiAccessEnabled = isFeatureEnabled(Feature.PublicApiAccess);

  const ownerAdminRoutes = [
    'team',
    'billing',
    'integrations',
    'tags',
    'appearance',
    'client-portal',
    'developers',
  ];

  const appearanceTabActive = location.pathname.includes('appearance');

  if (
    !isProviderUserOwnerOrAdminAuthorized(authedProviderUser) &&
    ownerAdminRoutes.some((route) => location.pathname.includes(route))
  ) {
    return <Navigate to="/settings" state={{ from: location }} replace />;
  }

  const tabList = [
    {
      route: '.',
      name: 'Account',
    },
    {
      route: 'notifications',
      name: 'Notifications',
    },
    ...(isProviderUserOwnerOrAdminAuthorized(authedProviderUser)
      ? [
          {
            route: 'team',
            name: 'Team',
          },
          {
            route: 'billing',
            name: 'Subscription',
          },
          {
            route: 'integrations',
            name: 'Integrations',
          },
          {
            route: 'tags',
            name: 'Tags',
          },
          {
            route: 'appearance',
            name: 'Appearance',
          },
          {
            route: 'client-portal',
            name: 'Client Portal',
          },
          ...(isPublicApiAccessEnabled
            ? [
                {
                  route: 'developers',
                  name: 'Developers',
                },
              ]
            : []),
        ]
      : []),
  ];

  return (
    <PageContainer
      containerClassName={classNames(
        'pb-0',
        appearanceTabActive && 'pr-0',
        showUpgradeBanner
          ? 'h-[calc(100vh-var(--top-nav-height)-var(--upgrade-banner-height))] overflow-y-hidden'
          : 'h-[calc(100vh-var(--top-nav-height))] overflow-y-hidden',
      )}
    >
      <PageTitle title="Settings" />
      <div className={classNames('w-full', appearanceTabActive && 'pr-[80px]')}>
        <Tabs tabList={tabList} fullWidth />
      </div>
      <div className="h-full w-full overflow-y-auto">
        <Outlet />
      </div>
    </PageContainer>
  );
};

export default Settings;
